import { render, staticRenderFns } from "./icon-pop-up.vue?vue&type=template&id=6c8bc292&"
import script from "./icon-pop-up.vue?vue&type=script&lang=js&"
export * from "./icon-pop-up.vue?vue&type=script&lang=js&"
import style0 from "./icon-pop-up.vue?vue&type=style&index=0&id=6c8bc292&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c8bc292')) {
      api.createRecord('6c8bc292', component.options)
    } else {
      api.reload('6c8bc292', component.options)
    }
    module.hot.accept("./icon-pop-up.vue?vue&type=template&id=6c8bc292&", function () {
      api.rerender('6c8bc292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homepage/component/icon-pop-up.vue"
export default component.exports